import { takeEvery, call, put } from 'redux-saga/effects';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { push, replace } from 'react-router-redux';
import queryString from 'qs';
import { ProjectTaskActions } from '../actions';

const projectTaskUrl = '/api/project-tasks';

export function* watchFetchProjectTasks() {
	yield takeEvery(ProjectTaskActions.FetchProjectTasks.Request, fetchProjectTasks);
}
function* fetchProjectTasks(action) {
	try {
		let projectTasks = yield call(fetchProjectTasksRequest, action.payload);

		yield put({
			type: ProjectTaskActions.FetchProjectTasks.Success,
			payload: projectTasks
		});
		let searchTermFilter = action.payload
			? queryString.stringify(action.payload, { skipNulls: true, addQueryPrefix: true })
			: '';
		yield put(replace(`${window.location.pathname}${searchTermFilter}`));
	} catch (err) {
		yield put({
			type: ProjectTaskActions.FetchProjectTasks.Failure
		});
		toastr.error(
			'Błąd pobierania projektów BO',
			'Wystąpił niespodziewany błąd podczas pobierania projektów budżetu obywatelskiego'
		);
	}
}
function fetchProjectTasksRequest(filter) {
	var query = queryString.stringify(filter, { skipNulls: true, addQueryPrefix: true });
	return axios.get(`${projectTaskUrl}${query}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchGetProjectTask() {
	yield takeEvery(ProjectTaskActions.GetProjectTask.Request, getProjectTask);
}
function* getProjectTask(action) {
	try {
		let projectTask = yield call(getProjectTaskRequest, action.payload);

		yield put({
			type: ProjectTaskActions.GetProjectTask.Success,
			payload: projectTask
		});
	} catch (err) {
		yield put({
			type: ProjectTaskActions.GetProjectTask.Failure
		});
		toastr.error(
			'Błąd pobierania projektu BO',
			'Wystąpił niespodziewany błąd podczas pobierania projektu budżetu obywatelskiego'
		);
	}
}
function getProjectTaskRequest(id) {
	return axios.get(`${projectTaskUrl}/${id}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchSearchProjectTasks() {
	yield takeEvery(ProjectTaskActions.SearchProjectTasks.Request, searchProjectTasks);
}
function* searchProjectTasks(action) {
	try {
		let projectTasks = yield call(fetchProjectTasksRequest, action.payload);

		yield put({
			type: ProjectTaskActions.SearchProjectTasks.Success,
			payload: projectTasks
		});
		let searchTermFilter = action.payload
			? queryString.stringify(action.payload, { skipNulls: true, addQueryPrefix: true })
			: '';
		yield put(replace(`${window.location.pathname}${searchTermFilter}`));
	} catch (err) {
		yield put({
			type: ProjectTaskActions.SearchProjectTasks.Failure
		});
	}
}
